export default "__VITE_ASSET__TlR1hWXI__"